import { lazy, Suspense } from 'react';
import { useParams } from 'react-router-dom';

const DetailsInventaire = lazy(() => import('@repo/ui/features/inventaires/details-inventaire/index'));

export default function InventaireDetailPage() {
  const { id = '' } = useParams<{ id?: string }>();
  const inventaireId = Number(id);

  if (Number.isNaN(inventaireId)) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <p className="text-sm text-muted-foreground">Identifiant d&apos;inventaire invalide.</p>
      </div>
    );
  }

  return (
    <Suspense fallback={<div className="flex items-center justify-center h-96">Loading inventory details...</div>}>
      <DetailsInventaire inventaireId={inventaireId} />
    </Suspense>
  );
}
